"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value === null;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isNull.js
// module id = 1830
// module chunks = 0